<div class="team-admin-view-container">
    <div class="nav-container">
        <div class="item clickable" [routerLink]="['/admin/team/', teamId, 'players']" routerLinkActive="active"> Manage Players </div>
        <!-- <div class="item clickable" [routerLink]="['/admin/team/', teamId, 'team']" routerLinkActive="active"> Manage Team </div> -->
    </div>
    <router-outlet></router-outlet>
</div>
